import { render } from "./sourcing-event-analysis.vue?vue&type=template&id=1b00050c&scoped=true"
import script from "./sourcing-event-analysis.vue?vue&type=script&lang=js"
export * from "./sourcing-event-analysis.vue?vue&type=script&lang=js"

import "./sourcing-event-analysis.vue?vue&type=style&index=0&id=1b00050c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b00050c"]])

export default __exports__